import { render, staticRenderFns } from "./InfoRentalIncome.vue?vue&type=template&id=223c1c97&"
import script from "./InfoRentalIncome.vue?vue&type=script&lang=js&"
export * from "./InfoRentalIncome.vue?vue&type=script&lang=js&"
import style0 from "./InfoRentalIncome.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/info-rental-income.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Facces-impot%2Facces-impot%2Flegacy%2Fpackages%2Facces-impot-front%2Fcomponents%2FAccount%2FReports%2FReport%2FReportRelevantQuestions%2FInfoRentalIncome.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports